import React from 'react';
import Button from '../Button';
import * as s from './styles';
const InfoBanner = ({ logoSrc, imageSrc }) => {
  const handleClick = () => {
    window.location.href = 'https://bluemed.cc/';
  };
  return (
    <s.BannerContainer>
      <s.Logo src={logoSrc} alt='Logo' />
      <s.TextContainer>
        <s.ParagraphFeatured>
          Com propriedades anti-inflamatórias e analgésicas, ele é perfeito para
          aliviar dores crônicas, melhorar a qualidade do sono e aumentar seu
          foco e clareza mental.
        </s.ParagraphFeatured>

        <s.MobileImage src={imageSrc} alt='Imagem' />
        <s.Paragraph>
          Enriqueça sua rotina diária com o óleo de CBD e sinta a diferença em
          seu bem-estar geral. Com ele você pode alcançar uma vida mais
          equilibrada e tranquila, uma solução natural para combater o estresse,
          a ansiedade e promover um sono reparador. Ideal para quem busca uma
          abordagem holística para a saúde, nosso óleo é extraído de plantas de
          cannabis de alta qualidade, garantindo pureza e eficácia.
        </s.Paragraph>
        <s.Paragraph>
          Com suas propriedades anti-inflamatórias e analgésicas, ele é perfeito
          para aliviar dores crônicas, melhorar a qualidade do sono e aumentar
          seu foco e clareza mental. Como parte de sua rotina matinal, o CBD se
          adapta às suas necessidades, trazendo equilíbrio e bem-estar.
        </s.Paragraph>

        <s.BtnMobile>
          <Button onClick={handleClick}>Fale com um Médico</Button>
        </s.BtnMobile>
      </s.TextContainer>
      <s.Image src={imageSrc} alt='Imagem' />
    </s.BannerContainer>
  );
};

export default InfoBanner;
